import { apiRequest } from "@/shared/lib/apiClient";

/** Nombre d'actes, consommation moyenne et totale, part de la dépense totale (%). */
export type SpendingStats = { acts: number; average: number; total: number; ratio: number };

export type ReportingFilters = {
  from: string;
  to: string;
  insurer_id?: number | null;
  hospital_id?: number | null;
  company_id?: number | null;
  batch?: string | null;
  /** Dépenses par assuré : famille (regroupée), agents, conjoints ou enfants. */
  insured?: "family" | "agent" | "spouse" | "child";
};

export type AdminReporting = {
  options: {
    insurers: Array<{ id: number; name: string }>;
    hospitals: Array<{ id: number; name: string }>;
    companies: Array<{ id: number; name: string; insurer_id: number }>;
    batches: string[];
  };
  key_figures: {
    extraction_date: string;
    insured: { total: number; agents: number; spouses: number; children: number };
    spending: { total: number; agents: number; spouses: number; children: number };
    invoices: { received: number; validated: number; rejected: number };
    amounts: { billed: number; refacted: number; validated: number };
    requests: { received: number; validated: number; rejected: number };
    by_package: Array<{ name: string; amount: number }>;
  };
  by_nature: Array<SpendingStats & { key: string; nature: string; codes: string[] }>;
  by_nature_detail: Array<SpendingStats & { key: string; nature: string; code: string; provider: string }>;
  by_provider: Array<SpendingStats & { name: string }>;
  by_pathology: Array<SpendingStats & { code: string | null; label: string }>;
  by_insured: Array<SpendingStats & { family_code: string; patient: string; insured: string }>;
};

export async function fetchAdminReporting(filters: ReportingFilters): Promise<AdminReporting> {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") params.set(key, String(value));
  });
  return apiRequest<AdminReporting>(`/admin/reporting?${params.toString()}`, { auth: true });
}
